<style scoped>
.wrap {
  width: 100%;
  height: 681px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  padding: 15px;
  margin-top: 10px;
  display: flex;
}
.wrap_left {
  width: 265px;
  /* height: 280px; */
  height: 318px;
  background: #f9f9f9;
  border-radius: 2px;
}
.left_info {
  width: 100%;
  /* height: 234px; */
  padding: 20px;
}
.info1 {
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  color: #333333;
}
.info2 {
  font-size: 20px;
  font-weight: 600;
  color: #e53631;
  line-height: 20px;
  margin-top: 15px;
}
.info3 {
  display: inline-block;
  margin-top: 15px;
}
.info3 div {
  font-size: 14px;
  color: #e53631;
  line-height: 14px;
  padding: 1px 4px;
  background: #ffe6e5;
  border-radius: 2px;
  margin-right: 6px;
  float: left;
  margin-bottom: 5px;
}
.info4 {
  font-size: 16px;
  color: #999999;
  line-height: 16px;
  margin-top: 10px;
}
.info5 {
  font-size: 16px;
  line-height: 16px;
  margin-top: 10px;
}
.contact_btn {
  width: 100px;
  background: #e53631;
  border-radius: 5px;
  font-size: 14px;
  color: #fff;
  line-height: 30px;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
}
.left_btns {
  display: flex;
}
.btn1 {
  width: 100%;
  height: 46px;
  background: #ffe6e5;
  font-size: 16px;
  color: #e53631;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn1 img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.btn2 {
  width: 50%;
  height: 46px;
  background: #e53631;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.wrap_right {
  width: 815px;
  height: 652px;
  background: #f9f9f9;
  margin-left: 10px;
  padding: 15px;
}
.detail_title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  line-height: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f2f2f2;
}

.wrap_line {
  width: 64px;
  height: 2px;
  background: #e53631;
  margin-top: -2px;
}
.toast_line {
  width: 96px;
  height: 2px;
  background: #e53631;
  margin-top: -2px;
}
.box_main {
  margin-top: 20px;
  display: flex;
  font-size: 14px;
  line-height: 14px;
  align-items: flex-start;
}
.main_title {
  width: 60px;
  color: #333333;
}
.main_content {
  color: #666666;
  margin-left: 30px;
}
.main_content2 {
  flex: 1;
  color: #666666;
  margin-left: 30px;
  /* line-height: 24px; */
}
.main_welfare {
  margin-left: 25px;
  display: flex;
}
.welfare_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 13px;
}
.welfare_box img {
  width: 50px;
  height: 60px;
}

/*  */
>>> .el-dialog__header {
  display: none;
}
>>> .el-dialog__body {
  padding: 15px;
}
.toast_box {
  width: 100%;
  height: 126px;
  background: #f9f9f9;
  margin-top: 15px;
  display: flex;
  align-items: center;
}
.toast_box img {
  width: 68px;
  height: 68px;
  margin-left: 11px;
}
.toast_tips {
  margin-left: 10px;
}
.toast_tips p:first-child {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
}
.toast_tips p:last-child {
  font-size: 14px;
  color: #999999;
  line-height: 14px;
  margin-top: 10px;
}
.toast_btn {
  width: 165px;
  height: 44px;
  background: #e53631;
  border-radius: 2px;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
  cursor: pointer;
}
</style>
<template>
  <div class="wrap">
    <div class="wrap_left">
      <div class="left_info">
        <p class="info1">{{detail.title}}</p>
        <p class="info2">{{detail.salary}}</p>
        <div class="info3"
             v-if="detail.tag">
          <div v-for="item in detail.tag.split(',')"
               :key="item">{{item}}</div>
          <!-- <div>免费培训</div> -->
        </div>
        <p class="info4">{{detail.companyName}}</p>
        <p class="info4">{{detail.city}} {{detail.area}}</p>
        <p v-if="detail.phone"
           class="info5">联系电话：{{detail.phone.substring(0,7)+'****' }}</p>
        <div class="contact_btn"
             @click="showContact">查看联系方式</div>
      </div>
      <div class="left_btns">
        <div class="btn1"
             @click="verify">
          <img :src="require(info.ifStart?'@/assets/img/icon_ysc.png':'@/assets/img/icon_sc.png')"
               alt="">
          <span>{{info.ifStart?'取消收藏':'收藏'}}</span>
        </div>
        <!-- <div class="btn2"
             @click="apply">{{info.ifApply?'已报名':'立即报名'}}</div> -->
      </div>
    </div>
    <div class="wrap_right">
      <p class="detail_title">兼职内容</p>
      <div class="wrap_line"></div>
      <div class="box_main"
           v-if="detail.openAddr">
        <div class="main_title">工作地址</div>
        <div class="main_content">{{detail.openAddr}}</div>
      </div>
      <div class="box_main"
           v-if="detail.jobDesc">
        <div class="main_title">工作内容</div>
        <div class="main_content2">{{detail.jobDesc}}</div>
      </div>
      <div class="box_main">
        <div class="main_title">招聘要求</div>
        <!-- <div class="main_content"
             v-if="detail.tag">{{detail.tag.replace(/,/g," | ")}}</div> -->
        <div class="main_content"
             v-if="detail.tag">{{detail.sex}}</div>
      </div>
      <div class="box_main"
           v-if="detail.welfare">
        <div class="main_title">工作福利</div>
        <div class="main_welfare"
             v-if="detail.welfare">
          <div class="welfare_box"
               v-for="item in detail.welfare.split(',')"
               :key="item">
            <img :src="require('../../assets/img/fuli_'+item+'.png')"
                 alt="">
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <el-dialog :visible.sync="dialogVisible"
               width="350px">
      <p class="detail_title">查看完整电话</p>
      <div class="toast_line"></div>
      <div class="toast_box">
        <img src="@/assets/img/shouji.png"
             alt="">
        <div class="toast_tips">
          <p v-if="detail.phone">{{replacePhone(detail.phone)}}</p>
          <p>{{detail.title}}</p>
        </div>
      </div>
      <div class="toast_btn"
           @click="closeToast">完成</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      jobCode: 0,
      info: {},//所有信息
      detail: {},//兼职内容详情
      dialogVisible: false,
      showPhone: '18167169145',//展示的电话号码
    }
  },
  created () {
    this.jobCode = this.$route.query.jobCode;
    this.getInfo();
  },
  methods: {
    getInfo () {
      this.$get("/app/api/v1/verify/detail", { jobCode: this.jobCode })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.info = res.data;
            this.detail = this.info.detail;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    },
    verify () {
      const token = sessionStorage.getItem('usercode');
      if (token) {
        let param = {
          jobCode: this.jobCode,
          ifStart: this.info.ifStart ? 1 : 0,
          jobType: 1
        }
        this.$post("/app/api/v1/verify/start", param, 1, 1)
          .then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.$message(this.info.ifStart ? '取消收藏' : '收藏成功');
              this.getInfo();
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          })
          .catch((error) => { });
      } else {
        this.$router.push({ name: 'login' });
      }

    },
    showContact () {
      this.dialogVisible = true;
    },
    apply () {
      let param = {
        jobCode: this.jobCode,
        ifApply: this.info.ifApply ? 1 : 0,
        jobType: 1
      }
      this.$post("/app/api/v1/verify/apply", param, 1, 1)
        .then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.$message(this.info.ifApply ? '取消报名' : '报名成功');
            if (!this.info.ifApply) {
              this.dialogVisible = true;
            }
            this.getInfo();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((error) => { });
    },
    replacePhone (str) {
      return str.replace(/\s/g, '').replace(/(^\d{3})(?=\d)/g, "$1-").replace(/(\d{4})(?=\d)/g, "$1-");
    },
    closeToast () {
      this.dialogVisible = false;
    }
  },
}
</script>